"use strict";

require("./mptt-selector.modal.js");

angular.module("core").component("mpttSelector", {
    templateUrl: require("./mptt-selector.component.html"),
    controller: function(gettextCatalog, ModalService, Language) {
        var _this = this;
        var unregister = Language.initializeController(this, "language", null);

        this.$onDestroy = function() {
            unregister();
        };

        this.selectElement = function() {
            this.isFetching = true;
            this.resource.$promise.then(function(tree) {
                ModalService.showModal({
                    templateUrl: require("./mptt-selector.modal.html"),
                    controller: "TreeSelectorController",
                    controllerAs: "selector",
                    inputs: {
                        $attrs: {
                            title: _this.actionText,
                            tree: tree,
                            selected: _this.selectedElement,
                            expanded: (_this.selectedElement && _this.selectedElement.path.slice(0)) || null,
                            autoExpandFirst: _this.autoExpandFirst,
                            validate: _this.validate,
                            readOnly: _this.readOnly
                        },
                        tree_options: {dirSelectable: true}
                    }
                }).then(function(modal) {
                    _this.isFetching = false;
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function(result) {
                        if (result) {
                            _this.selectedElement = result;
                            _this.model = result.id;
                        }
                        modal.element.remove();
                    });
                });
            });
        };
    },
    bindings: {
        labelText: "<",
        resource: "<",
        model: "=?",
        isSubmit: "<?",
        formValidator: "=?",
        validate: "=?",
        selectedElement: "=?",
        actionText: "<?",
        inputName: "@?",
        readOnly: "<?",
        autoExpandFirst: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/mptt-selector/mptt-selector.component.js
// module id = 547
// module chunks = 0